'use strict';

angular.module('directives.empStaging')

.controller('empStagingMatchingController', ['$scope', '$state', '$modal', 'employeeSyncService', function ($scope, $state, $modal, employeeSyncService) {

    $scope.ctrlCtxt = {};

    // Toggle Details Collapse
    $scope.toggleDetailsCollapse = function () {
        if ($scope.readOnly) return;

        if (!$scope.showStagingDetails()) {
            $scope.selectedMatching.selectedMatchingID = $scope.model.PubEmp_MatchingStagingID;
            return;
        }

        $scope.selectedMatching.selectedMatchingID = null;
    };

    // Show Staging Details
    $scope.showStagingDetails = function () {
        if (_.isUndefined($scope.selectedMatching)) return;

        return $scope.selectedMatching.selectedMatchingID === $scope.model.PubEmp_MatchingStagingID;
    }

    // Get Other Stagings
    if (!$scope.readOnly && $scope.model.PubEmp_MatchingStagingID) {
        employeeSyncService
            .getStagingsByMatching($scope.model.PubEmp_MatchingStagingID)
            .then(function (stagings) {
                $scope.otherStagings = _.reject(stagings, { PubEmp_StagingID: $scope.model.PubEmp_StagingID });
            });
    }

    // Can Show Other Stagings?
    $scope.canShowOtherStagings = function () {
        if ($scope.readOnly) return false;
        if (!$scope.showStagingDetails()) return false;
        if (_.isUndefined($scope.otherStagings)) return;

        return $scope.otherStagings.length > 0;
    };

    // Toggle Other Stagings
    $scope.toggleOtherStagingsCollapse = function ($event) {
        $event.stopPropagation();
        if ($scope.readOnly) return;

        $scope.ctrlCtxt.showOtherStagings = !$scope.ctrlCtxt.showOtherStagings;
    };

    // Show Matching Actions
    $scope.showMatchingActions = function () {
        if ($scope.readOnly) return false;
        if (!$scope.showStagingDetails()) return false;
        if ($scope.showConfirmMatchingAction()) return true;
    };

    // Show Confirm Matching Action
    $scope.showConfirmMatchingAction = function () {
        return true;
    };

    // Show Confirm Matching Modal
    $scope.showConfirmMatchingModal = function ($event) {
        $event.stopPropagation();
        if ($scope.readOnly) return false;

        var modalScope = $scope.$new(true);
        modalScope.model = $scope.model;
        modalScope.ctrlCtxt = $scope.ctrlCtxt;

        // Get Ignored Matchings When Confirm Matching
        employeeSyncService
              .getIgnoredMatchingsWhenConfirmMatching($scope.model)
              .then(function (ignoredMatchings) {
                  modalScope.ignoredMatchings = ignoredMatchings;
              });

        var confirmMatchingModal = $modal({
            scope: modalScope,
            template: require('./empStagingDirective-matching-confirmModal.tpl.html'),
            placement: 'center'
        });

        modalScope.hideModal = function () {
            return confirmMatchingModal.$promise.then(confirmMatchingModal.hide);
        }

        modalScope.okModal = function () {
            modalScope.hideModal();
        }

        modalScope.refreshPage = function () {
            window.location.reload();
            // $state.reload();  Bug with UI-Router 0.2.13, fixed in 0.2.15 (produces more bugs elsewhere)
        };

        // Confirm Matching
        modalScope.confirmMatching = function () {
            $scope.ctrlCtxt.isLoading = true;

            employeeSyncService
                .getLatestBatch()
                .then(function (latestBatch) {
                    if (!_.isUndefined($scope.boxContext) && !_.isUndefined($scope.boxContext.latestClosedBatch)) {
                        modalScope.isLatestBatchDifferent = latestBatch.PubEmp_BatchID !== $scope.boxContext.latestClosedBatch.PubEmp_BatchID;
                    }

                    if (!modalScope.isLatestBatchDifferent) {
                        return employeeSyncService
                                .confirmMatching($scope.model)
                                .then(function () {
                                    return $scope.refreshMatchingsAndExceptions()
                                                 .then(function () {
                                                    modalScope.hideModal();
                                                 });
                                });
                    }
                })
                .finally(function () {
                    scope.ctrlCtxt.isLoading = false;
                });

        };
    };
}]);
